import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import './Checkout.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

export default function CheckoutSuccess() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_BASE}/orders/${orderId}`)
      .then((res) => setOrder(res.data))
      .catch(() => setOrder(null))
      .finally(() => setLoading(false));
  }, [orderId]);

  if (loading) return <div className="checkout-page"><p>Memuat...</p></div>;

  return (
    <div className="checkout-page">
      <div className="checkout-empty" style={{ textAlign: 'center' }}>
        <h1 style={{ fontFamily: 'Unbounded, sans-serif', color: '#C9A66B', fontSize: 22 }}>
          Pesanan Diterima! 🎉
        </h1>
        <p>Nomor pesanan kamu: <b>#{orderId}</b></p>
        {order && <p>Total: Rp {Number(order.total_amount).toLocaleString('id-ID')}</p>}
        <p style={{ maxWidth: 420, fontSize: 14 }}>
          Tim Saskara Record akan menghubungi kamu via email/WhatsApp untuk konfirmasi pembayaran dan pengiriman.
        </p>
        <Link to="/" className="checkout-back">← Kembali ke Beranda</Link>
      </div>
    </div>
  );
}
